import { useEffect } from 'react';

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || '';

interface StepPageSEOProps {
  stepId: string;
  stepLabel: string;
}

export default function StepPageSEO({ stepId, stepLabel }: StepPageSEOProps) {
  useEffect(() => {
    const siteUrl = SITE_URL.replace(/\/$/, '');
    const pageUrl = `${siteUrl}/steps/${stepId}`;
    const prevTitle = document.title;
    document.title = `STEP${stepId}｜${stepLabel} | 鳥取ではじめての家づくり`;

    const metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const prevDesc = metaDesc?.content;
    if (metaDesc) {
      metaDesc.content = `鳥取の家づくり「${stepLabel}」ステップの記事一覧。間取り・資金計画・住宅会社選びなど、失敗しない家づくりの知識をわかりやすく解説します。`;
    }

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'ホーム',
          item: siteUrl || '/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '家づくりのステップ',
          item: `${siteUrl}/#content`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: stepLabel,
          item: pageUrl,
        },
      ],
    };

    const collectionSchema = {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: `STEP${stepId}｜${stepLabel}`,
      url: pageUrl,
      description: `鳥取の家づくり「${stepLabel}」ステップの記事一覧。`,
      inLanguage: 'ja',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbSchema.itemListElement,
      },
    };

    const existing = document.getElementById('step-schema');
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = 'step-schema';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify([breadcrumbSchema, collectionSchema]);
    document.head.appendChild(script);

    return () => {
      document.getElementById('step-schema')?.remove();
      document.title = prevTitle;
      if (metaDesc && prevDesc) metaDesc.content = prevDesc;
    };
  }, [stepId, stepLabel]);

  return null;
}
